/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Start_FailedInputs */



/**
* | output |
* | --- |
* | "The recording could not start. Check your microphone and try again." |
*
* @param {Meeting_Offline_Start_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_start_failed = /** @type {((inputs?: Meeting_Offline_Start_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Start_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De opname kon niet starten. Kijk je micro na en probeer opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'enregistrement n'a pas pu démarrer. Vérifiez votre micro et réessayez.")
	return /** @type {LocalizedString} */ ("The recording could not start. Check your microphone and try again.")
});